/* eslint-disable camelcase */
export const self_reject = {
  'your-answer-has-been-received': 'Շնորհակալությո՛ւն Ձեր պատասխանը գրանցվել է',
  'do-you-want-reject-vacancy': 'Ցանկանո՞ւմ եք հրաժարվել թափուր հաստիքից։',
  'choose-reject-reason': 'Ընտրեք հրաժարվելու պատճառը',
  'reject-reason': 'Հրաժարվելու պատճառը',
  'to-reject': 'Հրաժարվել',
};
